import script from "./ProductCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCategory.vue?vue&type=script&setup=true&lang=js"

import "./ProductCategory.vue?vue&type=style&index=0&id=1e4b0317&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4b0317"]])

export default __exports__